import React from "react";
import { t } from "locales";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import FullWidthPageBackground from "components/FullWidthPageBackground";
import "./style.scss";

export default function BlockAboutFindACoach() {
  return (
    <div className="block-about-find-a-coach">
      <FullWidthPageBackground className="block-about-find-a-coach__background" />
      <div className="block-about-find-a-coach__content mx-auto text-center d-flex __column __align-center">
        <h2 className="h2 mb-4">{t("Trusted by leading universities and ambitious finance students worldwide")}</h2>
        <div className="subtitle-1 fw-semibold mb-5">
          {t("Turning academic excellence into real-world career success")}
        </div>
        <BaseButton className="block-about-find-a-coach__btn body-1 fw-bold pl-4 pr-3" to={"/coaches"} large borderless>
          {t("Find a Coach")}
          <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
        </BaseButton>
      </div>
    </div>
  );
}
